export default "__VITE_ASSET__6e4d2932__"